export default __webpack_public_path__ + "static/rec-2006-a05f372e6f0f9b43e314732d1984d512.png";